export function useMobileMode() {
  return !!(window as any).cordova
}
